import React from 'react';
import { AppInput, AppInputProps } from '../app-input';

export const AppHeightInput: React.FC<AppInputProps> = (props) => {
  return <AppInput {...props} type={'number'} disableClearable={true} />;
};
